import * as React from 'react';
import { useClearCache } from 'react-clear-cache';

const CacheBuster = (props: any) => {
    const { isLatestVersion, emptyCacheStorage } = useClearCache();

    setTimeout( () => {
        if (!isLatestVersion) {
            console.log('A new version is available')
            if (window.confirm('We\'ve released a new version. Do you wish to load changes ?')) {
                emptyCacheStorage()
            }
        } else {
            console.log('App is up to date')
        }
    }, 3000)
    

    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};

export default CacheBuster;